import React from "react";
import LegalPage from "pages/LegalPage.js";

export default ({ headingText = "Privacy Policy" }) => (
  <LegalPage source="privacy-policy.json" headingText={headingText} />
);
